import { api } from './apiClient'

export const RequestDataApi = {
  /**
   * Create a new data request.
   */
  requestData(data) {
    return api.post('/api/data-requests', data)
  },

  /**
   * Get data requests with optional filters and OData paging.
   * @param {{ status?: string, userId?: string, $top?: number, $skip?: number, $count?: boolean }} params
   */
  getRequests(params = {}) {
    return api.get('/api/data-requests', params)
  },

  /**
   * Update a data request's status.
   */
  updateStatus(requestId, status) {
    return api.patch(`/api/data-requests/${requestId}/status`, { status })
  },

  /**
   * Delete a data request.
   */
  deleteRequest(requestId) {
    return api.delete(`/api/data-requests/${requestId}`)
  }
}
